/**
 * Shared TanStack Query staleTime tiers, mirroring the backend's
 * CACHE_TTL.SCHEDULER_AGG / CACHE_TTL.REFERENCE_DATA convention
 * (src/utils/requestCache.js in data-collector-be): env-overridable at the
 * tier level, not per consumer, so tuning one tier doesn't require juggling
 * a separate env var per hook.
 */

function parseIntEnv(raw: string | undefined, fallback: number): number {
  const parsed = raw ? parseInt(raw, 10) : NaN;
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
}

export const CACHE_TTL = {
  /** Frequently-changing, multi-user state (team rosters, schedules, payment stats). */
  INTERACTIVE: parseIntEnv(import.meta.env.VITE_CACHE_TTL_INTERACTIVE_MS, 30_000),
  /** Slow-changing, per-project data (demographic answers, screener questions). */
  REFERENCE: parseIntEnv(import.meta.env.VITE_CACHE_TTL_REFERENCE_MS, 5 * 60 * 1000),
} as const;

export const TEAM_DATA_STALE_TIME_MS = CACHE_TTL.INTERACTIVE;
export const ACTION_CENTER_STALE_TIME_MS = CACHE_TTL.INTERACTIVE;
export const PROJECT_SCHEDULES_STALE_TIME_MS = CACHE_TTL.INTERACTIVE;
export const DEMOGRAPHICS_TABLE_STALE_TIME_MS = CACHE_TTL.REFERENCE;
